import React from "react";
import { Link, useNavigate } from "react-router-dom";
import CardImg from "../../assets/images/courses/course.jpg";
import "./styles.scss";
import { FaCartArrowDown } from "react-icons/fa6";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { addToCart, fetchCartItems } from "../../store2/features/cartSlice";
import Thumbimg from "../../assets/images/courses/course_thumb01.jpg";
import { useScroll } from "../../router/Scroll/ScrollContext";
import { callAlert, getUserDetails } from "../../services/CommonService";

export default function LearningCard(props) {
  const { course } = props;

  const dispatch = useDispatch();
  const cartItems = useSelector((state) => state.cart.items);
  const { scrollToSection } = useScroll();
  const navigate = useNavigate();

  // const notify = () => toast.success(`${course.courseName} added to cart`);
  const notify = () =>
    toast.success(
      <>
        {course?.courseName} <strong>added to cart</strong>
      </>,
    );

  const userDetailss = getUserDetails();

  const handleAddToCart = async () => {
    console.log(userDetailss, "user details---------------------------------");
    if (!userDetailss) {
      toast.error(
        <>
          Please <strong>login first</strong>
        </>,
        { theme: "colored" },
      );
    } else {
      const moduleList = course?.modules.map((module) => module.id);

      const result = await dispatch(
        addToCart({ courseId: course.id, moduleList: moduleList }),
      );

      if (result.payload?.resultCode != 1) {
        callAlert("", result.payload?.message);

        return;
      }

      await dispatch(fetchCartItems());

      scrollToSection("top");
      notify();
      const timeoutId = setTimeout(() => {
        navigate("/cart");
      }, 2000);
      return () => clearTimeout(timeoutId);
    }
  };

  const truncateText = (text, maxLength) => {
    if (text.length > maxLength) {
      return text.substring(0, maxLength) + "..."; // Add ellipsis to indicate truncation
    } else {
      return text;
    }
  };

  const getCourseRoute = (course) => {
    const board = course?.board?.toUpperCase();
    if (board === "CBSE" || board === "ICSE") {
      // if (board === "CBSE" || board === "ICSE") {
      return `/course-details/${course.id}#course-details`;
    }
    return `/other-course-details/${course.id}`;
  };

  return (
    <>
      <div className="learningcard-wrap mb-5">
        <div className="card-course">
          <div className="courses-thumb">
            {/* <div
              className="courses-tags"
              // style={{
              //   backgroundColor: course.board && course.board == 'ICSE' ? "#213c95" : course.board && course.board == 'CBSE' ? "#277077" : course.board && course.board.length < 3 ? "#8B0000" : course.board && course.board.length < 6 ? "#00008B" : course.board && course.board.length < 8 ? "#006400" : "#B8860B"
              // }}
              style={{ backgroundColor: "#277077" }}>
              {course.board} / {course.grade}
              Class / Board
            </div> */}

            {/*  <div
              className="courses-tags"
              style={{
                backgroundColor:
                  course.board && course.board == "ICSE"
                    ? "#213c95"
                    : course.board && course.board == "CBSE"
                    ? "#277077"
                    : course.board && course.board.length < 3
                    ? "#8B0000"
                    : course.board && course.board.length < 6
                    ? "#00008B"
                    : course.board && course.board.length < 8
                    ? "#006400"
                    : "#B8860B",
              }}
            >
              {course.board} / {course.grade}
            </div> */}
          </div>

          <div className="course-card-image">
            {/* <Link to={`/course-details/${course.id}#course-details`}> */}
            <Link to={getCourseRoute(course)}>
              <img
                src={course.image}
                alt=""
                className="card-course-image"
                style={{ height: "200px" }}
              />
            </Link>
          </div>
          <div className="course-card-content">
            <div className="title-box">
              {/* <Link
                // to={`/course-details/${course.id}`}
                to={`/course-details/${course.id}#course-details`}
                className="text-decoration-none"
              > */}
              <Link
                // to={`/course-details/${course.id}`}
                to={getCourseRoute(course)}
                className="text-decoration-none"
              >
                <h4 className="card-title">{course?.courseName}</h4>
              </Link>
            </div>
            <hr />
            <div className="d-flex justify-content-between align-item-center mt-3">
              <div className="price-card">
                <span>₹{course.price}</span>
                {/* <span className="link-text">₹{course.price}</span> */}
              </div>
              <button
                className="btn btn-primary"
                title=" Add to cart"
                onClick={handleAddToCart}
              >
                <FaCartArrowDown />
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
